var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "38px",
    viewBox: "0 0 42 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "block_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("g", {
    id: "block_icon",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.409375,18.1365556 C41.671875,23.3093056 39.834375,28.2266111 36.225,32.0582778 C32.55,35.8260833 27.628125,37.9335 22.3125,37.9973611 L22.18125,37.9973611 C11.55,37.9973611 2.8875,29.4399722 2.8875,18.9028889 L2.8875,18.392 L1.640625,18.392 C1.246875,18.392 0.91875,18.2004167 0.721875,17.8811111 C0.525,17.5618056 0.525,17.1786389 0.7875,16.8593333 L4.2,11.7504444 C4.396875,11.4311389 4.725,11.3034167 5.053125,11.3034167 C5.38125,11.3034167 5.709375,11.495 5.90625,11.7504444 L9.31875,16.8593333 C9.515625,17.1786389 9.515625,17.5618056 9.384375,17.8811111 C9.1875,18.2004167 8.859375,18.392 8.465625,18.392 L7.21875,18.392 L7.21875,18.9028889 C7.21875,27.0771111 13.9125,33.7186667 22.115625,33.7825278 L22.18125,33.7825278 C26.38125,33.7825278 30.384375,32.0582778 33.271875,29.0568056 C36.159375,25.9914722 37.5375,22.0320833 37.14375,17.8811111 C36.4875,10.5370833 30.253125,4.85344444 22.70625,4.598 C19.81875,4.53413887 16.996875,5.23661113 14.503125,6.64155556 C14.175,6.83313887 13.78125,6.96086113 13.3875,6.96086113 C12.73125,6.96086113 12.075,6.64155556 11.68125,6.13066665 C11.2875,5.68363887 11.15625,5.04502778 11.2875,4.47027778 C11.41875,3.89552778 11.746875,3.38463889 12.271875,3.06533333 C15.225,1.34108333 18.6375,0.447027778 22.115625,0.447027778 L22.18125,0.447027778 C32.41875,0.383166665 40.884375,8.17422222 41.409375,18.1365556 L41.409375,18.1365556 L41.409375,18.1365556 Z M20.08125,17.1786389 C20.7375,16.5400278 21.65625,16.2845833 22.509375,16.4123056 L28.021875,11.8143056 C28.48125,11.4311389 29.1375,11.4311389 29.596875,11.8781667 C30.05625,12.3251944 30.05625,12.9638056 29.6625,13.4108333 L24.9375,18.8390278 C25.06875,19.6692222 24.80625,20.5632778 24.15,21.2018889 C23.034375,22.2875278 21.196875,22.2875278 20.08125,21.2018889 C18.965625,20.0523889 18.965625,18.3281389 20.08125,17.1786389 L20.08125,17.1786389 L20.08125,17.1786389 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockIcon);
export default __webpack_public_path__ + "static/media/block_icon.30b7baccce1b5004e58248bc8840c0e3.svg";
export { ForwardRef as ReactComponent };